var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m387.995 30h18.005c8.284 0 15-6.716 15-15s-6.716-15-15-15h-300c-8.284 0-15 6.716-15 15s6.716 15 15 15h18.005l-31.97 81.523c-.684 1.746-1.035 3.603-1.035 5.477v300c0 1.227.15 2.448.448 3.638l20 80c1.669 6.677 7.669 11.362 14.552 11.362h260c6.883 0 12.883-4.685 14.552-11.362l20-80c.298-1.19.448-2.411.448-3.638v-300c0-1.874-.351-3.731-1.035-5.477zm-231.765 0h199.54l28.235 72h-256.01zm218.059 452h-236.578l-12.5-50h261.577zm16.711-80h-270v-270h270z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 362c52.383 0 95-42.617 95-95s-42.617-95-95-95-95 42.617-95 95 42.617 95 95 95zm0-160c35.841 0 65 29.159 65 65s-29.159 65-65 65-65-29.159-65-65 29.159-65 65-65z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.7ff341b4ee3628da06fc12efad15d9e7.svg";
export { ForwardRef as ReactComponent };